export default __webpack_public_path__ + "static/media/enter-organization-welcome.f2760015.png";